// extracted by mini-css-extract-plugin
module.exports = {"pictureContainer":"SellerProductDetailFormModal_pictureContainer__2Skku","pictureOuterContainer":"SellerProductDetailFormModal_pictureOuterContainer__2bLBK"};